import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import SiteRouter from './SiteRouter'
import './styles.css'
import { installAdsMeasurement } from './measurement/googleAds'

const disposeAds = installAdsMeasurement()
if (import.meta.hot) import.meta.hot.dispose(disposeAds)

const container = document.getElementById('root')
if (!container) throw new Error('Elemento #root ausente no documento.')

const application = (
  <StrictMode>
    <SiteRouter />
  </StrictMode>
)

// No site publicado o HTML já vem com o conteúdo (pré-render do build): só hidrata.
// No servidor de desenvolvimento o #root chega vazio: monta do zero.
if (container.hasChildNodes()) {
  hydrateRoot(container, application)
} else {
  createRoot(container).render(application)
}
